import AntHistogram from "../../../charts/ant/AntHistogram";
import {computeLogReturns} from "../../../utils/math";
import {Row, Col, Card} from 'antd';
import Explainer from "../../../components/Explainer";
const ReturnsDistributions = ({items, itemColors})=>{

    return (
        <Row gutter={[0, 0]} className={'bordered-columns'}>
            {items.map((item, idx)=>{
                return (
                    <Col xs={24} xl={12}>
                        <Card bordered={false} title={<Explainer title={item.label}/>} style={{height: 500}}>
                            <div style={{height: 400}}>
                                <AntHistogram data={computeLogReturns(item.chart.map(x=>x[1]))} color={itemColors[item.id]} />
                            </div>
                        </Card>

                    </Col>
                )
            })}
        </Row>
    )
}

export default ReturnsDistributions;